<template>
  <mf-loading-dialog :loading="loading">
    <base-page-layout title="Resultados da consulta">
      <mf-button label="Voltar" color="marca-0-l40" icon="arrow_back" icon-position="left" text @click="goBack" />
      <v-card class="margin-bottom mt-2">
        <v-card-text>
          <consumer-header :consumer="consumer" :startDate="startDate" :endDate="endDate" />
          <v-divider class="my-4"></v-divider>
          <div :class="{ 'mb-2': !activatedDate }">
            <span class="bold-22px color-marca-0-l10">Cashback ativo: </span>
            <span class="bold-22px color-marca-0-l30">R${{ localeString(wallet.activatedAmount || 0, 2) }}</span>
          </div>
          <div v-if="activatedDate" class="mb-2">
            <span class="normal-14px color-cinza-0">Ativado em: {{ activatedDate }}</span>
          </div>
          <div v-if="hasCashbackModule" class="d-flex flex-row align-center" style="gap: 4px">
            <span class="normal-14px color-marca-0-l30">Cashback restante na carteira: </span>
            <span class="bold-16px color-marca-0-l30">R${{ localeString(wallet.amount || 0, 2) }}</span>
          </div>
          <div class="d-flex flex-row align-center mb-2" style="gap: 4px">
            <span class="normal-14px color-orange">Cashback bloqueado: </span>
            <span class="bold-16px color-orange">R${{ localeString(wallet.blockedAmount || 0, 2) }}</span>
          </div>

          <cashback-unlock-dialog v-if="wallet.blockedAmount > 0" :document-no="consumer.documentNo" @cashbackUnlocked="getData" />
          <cashback-history-table class="mt-4" :history="history" />
        </v-card-text>
      </v-card>
    </base-page-layout>
  </mf-loading-dialog>
</template>

<script>
import { DateTime } from 'luxon'
import { localeString } from '@/config/helpers.js'
import BasePageLayout from '@/components/BasePageLayout.vue'
import { QUERY_USER_CASHBACK_WALLET, QUERY_USER_CASHBACK_HISTORY, QUERY_USER_NEXT_BUY_CASHBACK_HISTORY } from '../../graphql'
import ConsumerHeader from '../components/ConsumerHeader.vue'
import CashbackUnlockDialog from '../components/CashbackUnlockDialog.vue'
import CashbackHistoryTable from '../components/CashbackHistoryTable.vue'

export default {
  components: {
    BasePageLayout,
    ConsumerHeader,
    CashbackUnlockDialog,
    CashbackHistoryTable,
  },
  props: {
    consumer: {
      type: Object,
      required: true,
    },
    startDate: {
      type: String,
      required: true,
    },
    endDate: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    wallet: {
      activatedAmount: 0,
      activatedDate: '',
      amount: 0,
      blockedAmount: 0,
      consumedAmount: 0,
      expired: 0,
    },
    history: [],
  }),
  computed: {
    hasCashbackModule() {
      return this.$getAllowedModules()['cashback']
    },
    activatedDate() {
      let activatedDate = null
      if (this.hasCashbackModule) {
        activatedDate = this.wallet?.activatedDate
      } else {
        activatedDate = this.history[0]?.date
      }
      return activatedDate ? DateTime.fromISO(activatedDate).toFormat('dd/MM/yyyy - HH:mm:ss') : null
    },
  },
  mounted() {
    if (typeof this.consumer !== 'object') {
      this.goBack()
    } else {
      this.getData()
    }
  },
  methods: {
    localeString,
    goBack() {
      this.$router.push({ name: 'consultar-cashback' })
    },
    mountQuery(query) {
      return this.$apollo.query({
        query: query,
        variables: {
          documentNo: this.consumer.documentNo,
          startDate: DateTime.fromISO(this.startDate).startOf('day').toFormat('yyyy-MM-dd HH:mm:ss'),
          endDate: DateTime.fromISO(this.endDate).endOf('day').toFormat('yyyy-MM-dd HH:mm:ss'),
        },
        fetchPolicy: 'no-cache',
      })
    },
    async getData() {
      this.loading = true
      try {
        const [resultWallet, resultCashbackHistory, resultNextBuyCashbackHistory] = await Promise.all([
          this.mountQuery(QUERY_USER_CASHBACK_WALLET),
          this.mountQuery(QUERY_USER_CASHBACK_HISTORY),
          this.mountQuery(QUERY_USER_NEXT_BUY_CASHBACK_HISTORY),
        ])
        const { wallet, industryWallet } = resultWallet.data.userCashbackWallets
        const userCashbackHistory = resultCashbackHistory.data.userCashbackHistory.data
        const userNextBuyCashbackHistory = resultNextBuyCashbackHistory.data.userNextBuyCashbackHistory.data

        this.history = [...userCashbackHistory, ...userNextBuyCashbackHistory]
        this.wallet = {
          activatedAmount: wallet.activatedAmount + industryWallet.activatedAmount,
          activatedDate: wallet.activatedDate,
          amount: wallet.amount + industryWallet.amount,
          blockedAmount: wallet.blockedAmount + industryWallet.blockedAmount,
          consumedAmount: wallet.consumedAmount + industryWallet.consumedAmount,
          expired: wallet.expired + industryWallet.expired,
        }
      } catch (err) {
        console.log(err)
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.margin-bottom {
  margin-bottom: 74px;
}

.bold-16px {
  font-size: 16px;
  font-weight: 700;
}

.bold-22px {
  font-size: 22px;
  font-weight: 700;
}

.normal-14px {
  font-size: 14px;
  font-weight: 400;
}

.color-marca-0-l10 {
  color: $marca-0-l10;
}

.color-marca-0-l30 {
  color: $marca-0-l30;
}

.color-orange {
  color: #f36600;
}

.color-cinza-0 {
  color: $cinza-0;
}
</style>
